var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import 'rxjs/add/operator/map';
import { apiEndpoints, CommonConstant, systemValues } from '../../app.constants';
import { BackendHttpService } from '../../core/backend-http.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { UserService } from '../user.service';
var CommonService = /** @class */ (function (_super) {
    __extends(CommonService, _super);
    function CommonService(router, translate, userService) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.userService = userService;
        return _this;
    }
    CommonService.prototype.getPlatforms = function () {
        var apiUrl = "" + apiEndpoints.getPlatform;
        return this.get(apiUrl).map(function (res) {
            return res.data;
        });
    };
    CommonService.prototype.storeUTMData = function (utmSource, utmCampaign, utmMedium) {
        if (utmSource) {
            localStorage.setItem('utm_source', utmSource);
        }
        if (utmCampaign) {
            localStorage.setItem('utm_campaign', utmCampaign);
        }
        if (utmMedium) {
            localStorage.setItem('utm_medium', utmMedium);
        }
    };
    CommonService.prototype.clearUTMData = function () {
        localStorage.removeItem('utm_source');
        localStorage.removeItem('utm_campaign');
        localStorage.removeItem('utm_medium');
    };
    CommonService.prototype.resolvePlatformIconUrl = function (platformName) {
        // fix the wrong platform name
        if (platformName === 'YouTube') {
            platformName = 'Youtube';
        }
        return systemValues.platformIconPath + "/" + platformName + ".svg";
    };
    CommonService.prototype.normalizeDataForActivityLineChart = function (data) {
        var activityLineChartData = [];
        var reachColor = this.userService.chartColors[0];
        var impressionColor = this.userService.chartColors[1];
        var engagementColor = this.userService.chartColors[2];
        if (data) {
            var reachLine_1 = {
                name: CommonConstant.REACH_NAME,
                data: [],
                color: reachColor,
                marker: {
                    symbol: CommonConstant.CHART_OPTIONS.LEGEND_SYMBOL_TYPE.CIRCLE,
                    fillColor: reachColor,
                },
            };
            var impressionsLine_1 = {
                name: CommonConstant.IMPRESSIONS_NAME,
                data: [],
                color: impressionColor,
                marker: {
                    symbol: CommonConstant.CHART_OPTIONS.LEGEND_SYMBOL_TYPE.CIRCLE,
                    fillColor: impressionColor,
                },
            };
            var engagementLine_1 = {
                name: CommonConstant.ENGAGEMENT_NAME,
                data: [],
                color: engagementColor,
                marker: {
                    symbol: CommonConstant.CHART_OPTIONS.LEGEND_SYMBOL_TYPE.CIRCLE,
                    fillColor: engagementColor,
                },
            };
            data.forEach(function (item) {
                var dateKpi = new Date(item.date);
                engagementLine_1.data.push([dateKpi.getTime(), Math.round(item.engagement)]);
                if (item.impression !== undefined) {
                    impressionsLine_1.data.push([dateKpi.getTime(), Math.round(item.impression)]);
                }
                else if (item.impressions !== undefined) {
                    impressionsLine_1.data.push([dateKpi.getTime(), Math.round(item.impressions)]);
                }
                reachLine_1.data.push([dateKpi.getTime(), Math.round(item.reach)]);
            });
            activityLineChartData.splice(0, 0, engagementLine_1);
            activityLineChartData.splice(0, 0, reachLine_1);
            activityLineChartData.splice(0, 0, impressionsLine_1);
            return activityLineChartData;
        }
    };
    return CommonService;
}(BackendHttpService));
export { CommonService };



// WEBPACK FOOTER //
// ./src/app/services/common/common.service.ts.pre-build-optimizer.js